/**
 * Created by mac on 2019-10-14
 */

const BuildingLockedWindow = BuildingInfoWindow.extend({ 
    onWindowLoaded: function (building) {
        this._super(building, "buildinglockedwindow");
    },

    getButton: function () {
        return {
            text: Messages.get("Go").toUpperCase(),
            width: cleverapps.styles.BuildingInfoWindow.button.width,
            onPressed: this.onPressed.bind(this)
        };
    },

    onPressed: function () {
        this.close();

        cleverapps.focusManager.distract({
            focus: "moveToCurrent",
            actions: [
                function (f) {
                    cleverapps.meta.getSelectedLocation().scrollTo(cleverapps.meta.getSelectedLocation().getBuilding(), f);
                },

                function (f) {
                    setTimeout(f, 500);
                },

                function (f) {
                    new QuestWindow();
                    cleverapps.focusManager.onceNoWindowsListener = f;
                }
            ]
        });
    },

    getInfo: function () {
        const activeBuilding = cleverapps.meta.getSelectedLocation().getBuilding();

        // eslint-disable-next-line no-restricted-syntax
        return cleverapps.UI.generateTTFText(Messages.get("BuildingLockedWindow.text", {
            currentBuilding: Messages.get(`building.${activeBuilding.name}`)
        }), cleverapps.styles.FONTS.WINDOW_TEXT);
    }
});